import { render } from "./SpinLoading.vue?vue&type=template&id=397481b6"
import script from "./SpinLoading.vue?vue&type=script&lang=js"
export * from "./SpinLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__